import { useMemo } from 'react';
import type { IDropdownInputOptions } from '@/_components/dropdown-input/dropdown-input';
import { useGetCitiesGeneralApi } from '../api/get-city-general-api';

type UseQueroDeliveryNeighborhoodsParams = {
  cityName: string;
};

export function useQueroDeliveryNeighborhoods({
  cityName,
}: UseQueroDeliveryNeighborhoodsParams) {
  const { data: city, isFetched } = useGetCitiesGeneralApi(
    { cityName },
    {
      enabled: !!cityName,
      retry: false,
    },
  );

  const neighborhoodsOptions = useMemo<IDropdownInputOptions[]>(() => {
    if (!city?.data?.geoLocalizacaoBairros) {
      return [];
    }

    return city.data.geoLocalizacaoBairros.map(neighborhood => ({
      key: neighborhood._id ?? neighborhood.bairro,
      text: neighborhood.bairro,
      value: neighborhood._id ?? neighborhood.bairro,
    }));
  }, [city]);

  return {
    city,
    neighborhoodsOptions,
    isNeighborhoodsQueryFetched: isFetched,
  };
}
